import React from 'react';

const Tabs = ({ children, handleTabChange, activeTab }) => {
  return (
    <div className='g-events-tab-header'>
      <div className='mob-game-tab'>
        {React.Children.map(children, (element) => {
          return React.cloneElement(element, {
            value: element.props.value,
            tab: element.props.tab,
            onChange: handleTabChange,
            selectedValue: activeTab,
          });
        })}

        <span className='mob-game-tab-switch' />
      </div>
    </div>
  );
};

export default Tabs;
